import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginTop: 2,
    marginBottom: 10,
    // paddingHorizontal: 20,
    // paddingVertical: 10,
    
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
    textAlign: 'left', // Centers the message for better readability
   
  },
});

const InvoiceThankYouMsg = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>
      The booking is powered by Holidays Seychelles {'\n'}
      Emergency number - +248 437 6666 {'\n'}
      Thanks for booking with us
    </Text>
  </View>
);

export default InvoiceThankYouMsg;
